import { has, isBoolean } from 'lodash'
import { PendingOperationEnum } from '../../../pending-operation/pending-operation.enum'

export enum CodeError {
  blockedEmail = 'BLOCKED_EMAIL',
  alreadyRegisteredEmail = 'USED_EMAIL',
  alreadyRegisteredNumber = 'USED_MOBILE',
  blockedCell = 'BLOCKED_MOBILE',
  invalid = 'NOV',
  accountNotFound = 'ACCOUNT_NOT_FOUND',
  otpRequestBlocked = 'OTP_REQUEST_BLOCKED',
  otpExpired = 'OTP_EXPIRED',
  otpBlocked = 'OTP_BLOCKED',
  accountAlreadyExists = 'ERR_ACCOUNT_ALREADY_EXISTS',
  unconfirmedAccountError = 'USER_NOT_CONFIRMED',
  wrongCredentials = 'WRONG_CREDENTIALS',
  generalError = 'ERR',
  userInUnhandledStatus = 'USER_IN_UNHANDLED_STATUS',
  emailSendingError = 'EMAIL_SENDING_ERROR',
  actionRequired = 'ACTION_REQUIRED',
  currentPasswordSameAsPrevious = 'SAME_ACTUAL_AND_NEW_PASSWORD',
  newPhoneSameAsPrevious = 'CHANGE_SAME_PHONE_ERROR',
  usedPhoneNumber = 'USED_PHONE_NUMBER',
  createUserError = 'CREATE_USER_ERROR',
  invalidInputName = 'INVALID_INPUT_NAME',
  invalidInputSurname = 'INVALID_INPUT_SURNAME',
  invalidInputBillingName = 'INVALID_INPUT_BILLING_NAME',
  invalidInputBillingSurname = 'INVALID_INPUT_BILLING_SURNAME',
  emailMagicLinkNotValid = 'INVALID_OTP',
  emailAlreadyVerified = 'EMAIL_ALREADY_CONFIRMED',
}

export interface BaseOutput<T = CodeError> {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  CodeError?: T
  // eslint-disable-next-line @typescript-eslint/naming-convention
  MessageError?: string
  // eslint-disable-next-line @typescript-eslint/naming-convention
  ActionRequired?: PendingOperationEnum
  // eslint-disable-next-line @typescript-eslint/naming-convention
  Success: boolean
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const isBaseOutput = <T>(output: any): output is BaseOutput<T> =>
  has(output, 'MessageError') && has(output, 'Success') && isBoolean(output['Success'])

export const isBaseOutputError = <T>(output: unknown): boolean =>
  isBaseOutput<T>(output) && has(output, 'CodeError') && !output['Success']
